import { Button, Dialog, EButtonColor } from '@web_opxp/components';
import { ETagType, renderStringToReact, useTranslation } from '@web_opxp/features';
import './TerminateConfirmationPopup.scss';

export interface ITerminateConfirmationPopupProps {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function TerminateConfirmationPopup({
  show,
  onClose,
  onConfirm,
}: Readonly<ITerminateConfirmationPopupProps>) {
  const { t } = useTranslation();
  const emailText = renderStringToReact(t('manage:Subscriptions.Confirmation.Email'), ETagType.span);
  return (
    <Dialog
      lazy={true}
      title={t('manage:Subscriptions.Confirmation.Questions')}
      autoFocus={true}
      isOpen={show}
      onClose={onClose}
      usePortal={true}
      className="terminate-subscription-dialog"
      bodyClassName="terminate-subscription-dialog-body"
      footerContent={
        <>
          <Button
            className="terminate-subscription-action"
            label={t('manage:Subscriptions.Actions.remainPremium')}
            onClick={onClose}
          />
          <Button
            className="terminate-subscription-action"
            color={EButtonColor.red}
            label={t('manage:Subscriptions.Actions.terminate')}
            onClick={onConfirm}
          />
        </>
      }>
      <h3>{t('manage:Subscriptions.Confirmation.WeHelpYou')}</h3>
      <p>{emailText}</p>
    </Dialog>
  );
}
